// The nyceOperations wordmark (the kit carries only the nyce mark).
import logoBlack from './ops_logo_black.svg';
import logoWhite from './ops_logo_white.svg';

export const logos = { logoBlack, logoWhite };
